import { MenuItem, TextField } from "@mui/material";
import i18n from "i18next";
import React, { useContext } from "react";
import LocaleActionContext from "../../contexts/LocaleActionContext";
import LocaleContext from "../../contexts/LocaleContext";
import LocalesContext from "../../contexts/LocalesContext";


const LanguageSelect: React.FC = () => {
    const { data: locales } = React.useContext(LocalesContext);
    const { data: locale } = useContext(LocaleContext);
    const { setLocale } = useContext(LocaleActionContext);

    const handlechange = React.useCallback(async (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        const newLocale = locales?.find(l => l.code == event.target.value);

        setLocale(newLocale);
    }, [locales, i18n, setLocale]);

    return (
        <TextField
            select
            // fullWidth
            value={locale?.code ?? "en"}
            onChange={(event) => handlechange(event)}
        >
            {
                locales?.map(l => (
                    <MenuItem key={l.code} value={l.code}>{l.name}</MenuItem>
                )) ?? 
                <MenuItem key="en" value="en">English</MenuItem>
            }
        </TextField>
    )
}

export default LanguageSelect;